import React from 'react';
import { StudyGuidePlayer } from '../study-guide-player';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';
import { GuideBlockPlayer } from '@/components/custom/guide';
import { isVimeoUrl } from '@/lib/utils';

export function StudyGuideBlockModal(props) {
  const { video } = props;

  return (
    <DialogContent size="md">
      <DialogTitle className="sr-only">Assista o vídeo</DialogTitle>

      <GuideBlockPlayer>
        {isVimeoUrl(video['video-url']) && (
          <StudyGuidePlayer
            key={video['video-url']}
            videoId={video['video-url']}
          />
        )}
      </GuideBlockPlayer>
    </DialogContent>
  );
}
